import PropTypes from 'prop-types';
import React from 'react';
import { formatCurrency } from 'ddc-intl';

const Mathbox = ({ options, locale }) => {
	if (options.length === 0) {
		return null;
	}
	return (
		<div className="mb-3">
			<ul className="list-unstyled list-spaced">
				{options.map((option, idx) => {
					const { name, price } = option;
					const displayPrice =
						price !== 0 ? (
							<span className="option-price ml-auto pl-5">
								{formatCurrency(price, locale)}
							</span>
						) : null;
					return [
						<li
							key={name}
							className={`${
								idx === options.length - 1
									? null
									: 'border-bottom mb-2 pb-2'
							}`}
						>
							<div className="d-flex">
								<span className="option-title">{name}</span>
								{displayPrice}
							</div>
						</li>
					];
				})}
			</ul>
		</div>
	);
};

Mathbox.defaultProps = {
	locale: 'en_US',
	options: []
};

Mathbox.propTypes = {
	locale: PropTypes.string,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			price: PropTypes.number.isRequired
		})
	)
};

export default Mathbox;
